
import { Prop, Component, Emit } from "vue-property-decorator";
import { IUITagResult, EUITagTarget } from "@root/core/tags/core";
import { BaseTableCore } from "./base-table-core";
import { ObjectHelper } from "@root/core/utilities";
import { IBaseComponentUITag } from "@root/components/interfaces";

@Component
export default class TableHeader extends BaseTableCore {
    @Prop({ type: Object, required: false })
    uiTag?: IBaseComponentUITag;

    /// event handler
    @Emit("update:sort")
    doUpdateSort(name, sort) {
        return { [name]: sort };
    }

    /// private helper
    bindCellPropertiesCustom(
        target: keyof typeof EUITagTarget,
        index,
        metaIndex,
    ): IUITagResult {
        const result = this.bindCellProperties(target, index, metaIndex, this.uiTag);
        if (result == null || result.props == null) return result;
        const props = result.props;

        /// passin "sort" from "query"
        if (target === "TableHeaderCell") {
            const orderBy = this.query.data?.orderBy;
            do {
                /// sanity check
                if (orderBy == null || this.metas == null || !Array.isArray(orderBy))
                    break;

                /// find the meta
                //const meta = this.metas[metaIndex];
                const meta = this.metas.getMetaByIndex(metaIndex);
                if (meta == null) break;

                const name = meta.attr.name;
                const sort = orderBy.reduce<string | null>((final, value) => {
                    do {
                        /// already got result
                        if (final != null) break;
                        /// not valid object
                        if (ObjectHelper.isEmpty(value)) break;
                        /// return sort
                        const oname = Object.keys(value)[0];
                        if (oname === name) return value[oname];
                    } while (0);
                    return final;
                }, null);

                /// apply the sort
                props.sort = sort;
            } while (0);
        }
        return result;
    }
}
